import { useEffect } from 'react';
import { Trophy, X } from 'lucide-react';
import { ArrowRightIcon } from '@phosphor-icons/react';
import { JEE_MAIN_BUY_URL } from './jeeMainPaywall';

// Shown when a student without an active JEE Main test series purchase tries to open the 99
// Percentile Challenge - the challenge itself is free, but gated behind that purchase as a
// product decision (not a backend rule).
export default function JeeMainPaywallSheet({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-end justify-center md:items-center">
      <div className="fixed inset-0 bg-black/40" onClick={onClose} />
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="jeeMainPaywallT"
        className="relative z-10 w-full max-w-md rounded-t-3xl bg-[var(--q3-surface-default)] p-6 pb-[calc(24px+env(safe-area-inset-bottom,0px))] shadow-2xl md:rounded-3xl md:p-8"
      >
        <button
          onClick={onClose}
          aria-label="Close"
          type="button"
          className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-[var(--q3-surface-dimmer)] text-[var(--q3-neutral-light)] cursor-pointer"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#fff6dc] text-[#e0a100]">
          <Trophy className="h-8 w-8" />
        </div>

        <h2 id="jeeMainPaywallT" className="text-center text-xl font-bold text-[var(--q3-neutral-default)]">
          Unlock the 99 Days 99 Percentile Challenge
        </h2>
        <p className="mt-2 text-center text-sm leading-relaxed text-[var(--q3-neutral-light)]">
          This challenge is currently available only for JEE Main or JEE Main + Advanced 2027 Test Series students.
        </p>

        <a
          href={JEE_MAIN_BUY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 flex min-h-[52px] w-full items-center justify-center gap-2 rounded-2xl bg-[var(--q3-neutral-default)] font-semibold text-[var(--q3-neutral-default_inverted)] no-underline"
        >
          Purchase Test Series
          <ArrowRightIcon weight="bold" className="h-4 w-4" />
        </a>
        <button
          onClick={onClose}
          type="button"
          className="mt-2 flex min-h-[44px] w-full items-center justify-center rounded-2xl bg-transparent text-sm font-semibold text-[var(--q3-neutral-light)] cursor-pointer"
        >
          Maybe later
        </button>
      </section>
    </div>
  );
}
